export const commishNotesConstants = {
    COMMISH_NOTES_REQUEST: 'COMMISH_NOTES_REQUEST',
    COMMISH_NOTES_SUCCESS: 'COMMISH_NOTES_SUCCESS',
    COMMISH_NOTES_FAILURE: 'COMMISH_NOTES_FAILURE'
};